import Questions from 'src/javascripts/components/questionnaires/Questions'

export default class QuestionnairesQuestionsNew {

  constructor() {}

  render() {

  	Questions();

  }

}